import { apiClient } from "api/ApiClient";
import { Mail } from "pages/statuses/Mail";

/**
 * メール送信
 * @param Mail メール送信情報
 */
const sendMail = async (mail: Mail) => {
    try {
        const response = await apiClient.post(`/mail`, mail);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
    }
};

/**
 * message.propertiesから自動送信メール内容取得
 */
 const getMailMessage = async (): Promise<any> => {
    try {
        const response = await apiClient.get(`/mail/message`);
        return Promise.resolve(response);
    } catch (e) {
        console.log(`error => `);
        console.log(e);
        return e;
    }
};

export const MailApi = {
    sendMail,
    getMailMessage,
};
